import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-900 min-h-screen w-full" }
const _hoisted_2 = { class: "px-4 py-8 mx-auto container" }
const _hoisted_3 = {
  key: 0,
  class: "w-full mt-6"
}
const _hoisted_4 = {
  key: 0,
  class: "py-12 flex justify-center"
}
const _hoisted_5 = {
  key: 1,
  class: "w-full"
}
const _hoisted_6 = { class: "bg-red-900 text-white p-4 rounded-lg mb-6" }
const _hoisted_7 = {
  key: 2,
  class: "text-center py-10 text-gray-400"
}
const _hoisted_8 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" }
const _hoisted_10 = {
  key: 1,
  class: "w-full mt-6"
}
const _hoisted_11 = {
  key: 0,
  class: "py-12 flex justify-center"
}
const _hoisted_12 = {
  key: 1,
  class: "w-full"
}
const _hoisted_13 = { class: "bg-red-900 text-white p-4 rounded-lg mb-6" }
const _hoisted_14 = {
  key: 2,
  class: "text-center py-10 text-gray-400"
}
const _hoisted_15 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_16 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FollowingTabs = _resolveComponent("FollowingTabs")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-2xl font-bold text-white mb-6" }, "Pratim", -1)),
      _createVNode(_component_FollowingTabs, {
        "active-tab": _ctx.activeTab,
        onChangeTab: _ctx.handleTabChange
      }, null, 8, ["active-tab", "onChangeTab"]),
      (_ctx.activeTab === 'products')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.showLoader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
                ])))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.error), 1)
                  ]))
                : (_ctx.followedProducts.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Ne pratite nijedan proizvod "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followedProducts, (product) => {
                          return (_openBlock(), _createBlock(_component_ProductCard, {
                            key: product.id,
                            product: product,
                            onUnfollow: _ctx.handleProductUnfollow
                          }, null, 8, ["product", "onUnfollow"]))
                        }), 128))
                      ]),
                      (_ctx.productsMeta && _ctx.productsMeta.totalPages > 1)
                        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
                            key: 0,
                            meta: _ctx.productsMeta,
                            "current-page": _ctx.productsCurrentPage,
                            "update-url": true,
                            onPageChange: _ctx.handleProductsPageChange
                          }, null, 8, ["meta", "current-page", "onPageChange"]))
                        : _createCommentVNode("", true)
                    ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 'users')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.showLoader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
                ])))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.error), 1)
                  ]))
                : (_ctx.followedUsers.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Ne pratite nijednog korisnika "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followedUsers, (user) => {
                          return (_openBlock(), _createBlock(_component_UserCard, {
                            key: user.id,
                            user: user,
                            onUnfollow: _ctx.handleUserUnfollow
                          }, null, 8, ["user", "onUnfollow"]))
                        }), 128))
                      ]),
                      (_ctx.usersMeta && _ctx.usersMeta.totalPages > 1)
                        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
                            key: 0,
                            meta: _ctx.usersMeta,
                            "current-page": _ctx.usersCurrentPage,
                            "update-url": true,
                            onPageChange: _ctx.handleUsersPageChange
                          }, null, 8, ["meta", "current-page", "onPageChange"]))
                        : _createCommentVNode("", true)
                    ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type"])
  ]))
}